
import i18n from '@/lang';
import MenuList from '@/components/MenuList.vue';
import MenuSvg from '@/components/svg/SvgMenu.vue';
import MenuCloseSvg from '@/components/svg/SvgClose.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    MenuList,
    MenuSvg,
    MenuCloseSvg
  }
})
export default class extends Vue {
  @Prop() activeScroll!: boolean; 

  @Watch('language')
  watchLanguage(lang: string): void {
    i18n.locale = lang;
    this.$emit('change-lang', lang)
  }

  get logoUrl() {
    return this.activeScroll? '/2022/logo.png' : '/2022/logo-white.png'
  }

  language = i18n.locale;
  menuOpen = false;

  changeLanguage(lang: string): void {
    this.language = lang;
  }

  handleClickMenu() {
    this.menuOpen = !this.menuOpen;
  }

  handleLink() {
    if (this.$route.name !== 'Home') {
      this.$router.push({ name: 'Home' })
    }
  }

}
